import React from 'react';
import { PlusIcon } from '../../appearence/icons/plus_icon';
import { popupOpenService } from '../../services/popupOpenService';
import { Button } from '@chapche/ui';

const AddNewFormButton = ({ selectWithTokensManager }) => {
    const handleAddNewSource = () => {
        popupOpenService.callToOpen(selectWithTokensManager.getPopupKey());
    };

    return (
        <Button
            variant="ghost"
            size="small"
            className="product__forms-add w-full justify-between"
            onClick={handleAddNewSource}
        >
            {selectWithTokensManager.getButtonTitle()}
            <PlusIcon nameOfClass="product__forms-plus ml-8" handleClick={() => null} />
        </Button>
    );
};

export default AddNewFormButton;
